import { render, staticRenderFns } from "./FamilyEdit.vue?vue&type=template&id=1cb16213"
import script from "./FamilyEdit.vue?vue&type=script&lang=js"
export * from "./FamilyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports